import React from 'react'
import styled from 'styled-components'
import convertHexToRGBA from '../../../helpers/HexToRgba'

import { useSelector, shallowEqual } from 'react-redux'

//////STYLED//////
const ScheduledPricesManagerStatusWrapper = styled.div`
	text-align: center;
	background-color: ${(props) => convertHexToRGBA(props.colorCode, 0.2)};
	color: ${(props) => props.colorCode};
	line-height: 32px;
	font-weight: bold;
	width: fit-content;
	padding: 0 10px;
	border-radius: 15px;
	margin: 0 auto;
`
//////STYLED//////

const ScheduledPricesManagerStatus = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	return (
		<ScheduledPricesManagerStatusWrapper colorCode={props.row?.priceCampaignStatus?.colorCode}>
			{translations[props.row?.priceCampaignStatus?.translationKey]}
		</ScheduledPricesManagerStatusWrapper>
	)
}

ScheduledPricesManagerStatus.propTypes = {}

ScheduledPricesManagerStatus.defaultPropTypes = {}

export default ScheduledPricesManagerStatus
